var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show == true
      ? _c("div", { staticClass: "gray" }, [
          _c("div", { staticClass: "dialog" }, [
            _c(
              "div",
              { staticStyle: { display: "inline-block", width: "100%" } },
              [
                _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "cancel",
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "inline-block", width: "100%" } },
              [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "label",
                    { staticClass: "paragraph", attrs: { for: "quantity" } },
                    [_vm._v("Quantity")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.quantity,
                        expression: "quantity"
                      }
                    ],
                    attrs: { id: "quantity" },
                    domProps: { value: _vm.quantity },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.quantity = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "label",
                    { staticClass: "paragraph", attrs: { for: "weight" } },
                    [_vm._v("Weight")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.weight,
                        expression: "weight"
                      }
                    ],
                    attrs: { id: "weight" },
                    domProps: { value: _vm.weight },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.weight = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.perms.includes("93")
                  ? _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "paragraph",
                            attrs: { for: "employee" }
                          },
                          [_vm._v("Employee")]
                        ),
                        _vm._v(" "),
                        _c("autocomplete", {
                          staticStyle: {
                            display: "inline",
                            float: "right",
                            width: "70%"
                          },
                          attrs: { id: "employee", type: 16 },
                          on: { input: _vm.setData },
                          model: {
                            value: _vm.employee,
                            callback: function($$v) {
                              _vm.employee = $$v
                            },
                            expression: "employee"
                          }
                        })
                      ],
                      1
                    )
                  : _c("div", { staticClass: "field" }, [
                      _c(
                        "label",
                        {
                          staticClass: "paragraph",
                          attrs: { for: "employeeDisabled" }
                        },
                        [_vm._v("Employee")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.employee,
                            expression: "employee"
                          }
                        ],
                        attrs: { id: "employeeDisabled", disabled: "" },
                        domProps: { value: _vm.employee },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.employee = $event.target.value
                          }
                        }
                      })
                    ]),
                _vm._v(" "),
                _vm.isIn == true
                  ? _c("div", { staticClass: "field" }, [
                      _c(
                        "label",
                        { staticClass: "paragraph", attrs: { for: "box" } },
                        [_vm._v("Box")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.box,
                            expression: "box"
                          }
                        ],
                        attrs: { id: "box" },
                        domProps: { value: _vm.box },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.box = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c(
                      "label",
                      { staticClass: "paragraph", attrs: { for: "joborder" } },
                      [_vm._v("Job Order")]
                    ),
                    _vm._v(" "),
                    _c("autocomplete", {
                      staticStyle: {
                        display: "inline",
                        float: "right",
                        width: "70%"
                      },
                      attrs: { id: "joborder", type: 58 },
                      on: { input: _vm.setJoborderData },
                      model: {
                        value: _vm.joborder,
                        callback: function($$v) {
                          _vm.joborder = $$v
                        },
                        expression: "joborder"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "label",
                    { staticClass: "paragraph", attrs: { for: "notes" } },
                    [_vm._v("Notes")]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.notes,
                        expression: "notes"
                      }
                    ],
                    attrs: { id: "notes" },
                    domProps: { value: _vm.notes },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.notes = $event.target.value
                      }
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "inline-block", width: "100%" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "buttons",
                    on: {
                      click: function($event) {
                        return _vm.button(_vm.button_name)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.buttonname))]
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddedf1e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddedf1e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/checkitem.vue
// module id = 853
// module chunks = 0